import { StatusVideochamadaEnum } from 'graphql/types.generated'

import { SalaEsperaVideochamadaMobileLayout } from './componentes/SalaEsperaVideochamadaMobileLayout'
import { SalaEsperaVideochamadaUsuariosExternosForm } from './componentes/SalaEsperaVideochamadaUsuariosExternosForm'
import { StatusSolicitacaoEntradaVideochamadaEnum } from './model-videochamada'

interface SalaEsperaVideochamadaUsuariosExternosViewMobileProps {
  nomeProfissional: string
  cboProfissional: string
  audioEnabled: boolean
  videoEnabled: boolean
  statusVideochamada: StatusVideochamadaEnum
  setAudioEnabled(value: boolean): void
  setVideoEnabled(value: boolean): void
  statusSolicitacao: StatusSolicitacaoEntradaVideochamadaEnum
  handleEntrarButtonClick(): void
}

export function SalaEsperaVideochamadaUsuariosExternosViewMobile(
  props: Readonly<SalaEsperaVideochamadaUsuariosExternosViewMobileProps>
) {
  const {
    nomeProfissional,
    cboProfissional,
    audioEnabled,
    videoEnabled,
    setAudioEnabled,
    setVideoEnabled,
    statusVideochamada,
    statusSolicitacao,
    handleEntrarButtonClick,
  } = props

  const sufixoCbo = cboProfissional ? ` | ${cboProfissional}` : ''

  return (
    <SalaEsperaVideochamadaMobileLayout
      audioEnabled={audioEnabled}
      videoEnabled={videoEnabled}
      setAudioEnabled={setAudioEnabled}
      setVideoEnabled={setVideoEnabled}
      subtitulo={`Chamada com ${nomeProfissional}${sufixoCbo}`}
    >
      <SalaEsperaVideochamadaUsuariosExternosForm
        nomeProfissional={nomeProfissional}
        statusVideochamada={statusVideochamada}
        statusSolicitacao={statusSolicitacao}
        handleEntrarButtonClick={handleEntrarButtonClick}
        isMobile
      />
    </SalaEsperaVideochamadaMobileLayout>
  )
}
